import { getApi, postApi } from '@utils/request';

const prefix = '/video/member/info';
const memberApi = {
  // 获取人员信息
  getUserInfo: (params) => getApi(`${prefix}/get`, params),
  // 更新人员信息
  update: (params) => postApi(`${prefix}/update`, params),
  // 保存商家认证信息
  saveMerAuth: (params) => postApi(`/merchant/auth/info/save`, params),
  // 商家类型查询接口
  getMerAuthInfo: () => getApi(`/user/merchant/info/get`),
  // 店铺类型获取后台类目
  getEndShopList: () => postApi(`/category/list`),
  // 获取客服电话
  getServicePhone: () => getApi('/client/url/list'),
  // 选择店铺类型
  saveStoreType: (params) => postApi('/app/storeType/add', params),
  // 获取用户已选择的店铺类型
  getSelectedShop: (params) => getApi('/app/storeType/get', params),
  // 行业分类列表
  getIndustryCategoryList: () => postApi('/community/industry/category/list'),
  // 获取DB信息
  getbdList: () => postApi('/bd/account/list'),
};
export default memberApi;
